var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('main',{staticClass:"position-relative",attrs:{"id":"app-content"}},[_c('header',{staticClass:"w-100 py-md-3 py-lg-4",attrs:{"id":"app-content-header"}},[_c('div',{staticClass:"container d-flex"},[_c('Logo',{staticClass:"d-lg-none"}),_c('NavUser')],1)]),_c('section',{staticClass:"container-lg"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }